import { useDataChange } from 'Simple/Data'

export function useOnToggleToolbar(props) {
  let setToolbarHidden = useDataChange({
    context: 'viewer',
    path: 'is_toolbar_hidden',
    viewPath: props.viewPath,
  })

  return function toggleToolbar() {
    setToolbarHidden(next => {
      next.is_toolbar_hidden = !next.is_toolbar_hidden
    })
  }
}
